<template>
	<div class="bankrecharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.push('/user')"></div>
			<div class="big_tit">{{ data.payment.bank }}</div>
		</div>
		<div class="bank_detail">
			<div class="item">
				<p class="info">
				{{$t('invest_qrcode.amount')}}
				<span>{{$t('currency')}}{{money}}</span>
				<span>{{actualAmount}}</span>
				</p>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.name')}}
				<span>{{ data.payment.username }}</span></p>
				<div class="copy_btn" @click="copy(data.payment.username)">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.account')}}
				<span>{{ data.payment.account }}</span></p>
				<div class="copy_btn" @click="copy(data.payment.account)">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item">
				<p class="info">{{$t('invest_bank.bank')}}
				<span>{{ data.payment.bank }}</span></p>
				<div class="copy_btn" @click="copy(data.payment.bank)">
					{{$t('invest_bank.copy')}}
				</div>
			</div>
			<div class="item" style="display: unset;">
				<div class="info">{{$t('Upload voucher')}}</div>
				<div class="group3 flex-col">
					<div class="layer1 flex-col justify-between">
						<van-uploader multiple :max-count="1" :max-size="5 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead1"
									  :before-read="beforeRead">
							<img
									class="img1"
									referrerpolicy="no-referrer"
									:src="front_img"
									v-if="front_img"
							/>
							<img
									class="img1"
									referrerpolicy="no-referrer"
									src="../images/user/front.png"
									v-else
							/>
						</van-uploader>
					</div>
				</div>



			</div>
			<!-- <div class="item">
				<p class="info">付款人：<input type="text" v-model.trim="pay_user" placeholder="请输入付款人"></p>
			</div>
			<div class="item">
				<p class="info">附言：<input type="text" v-model.trim="pay_remark" placeholder="请输入充值附言"></p>
			</div> -->
		</div>
		<div class="basic_btn" @click="submitBtn">{{$t('utils.submit')}}</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Button, Icon, Popup, Toast, Uploader
	} from "vant";
	import Fetch from "../../utils/fetch";
	import Clipboard from "v-clipboard";
	import axios from "axios";
	import Api from "@/interface";

	Vue.use(Button).use(Clipboard);
	Vue.use(Uploader).use(Popup).use(Icon);

	export default {
		name: "invest_bank",
		data() {
			return {
				data: {},
				pay_user: '',
				pay_remark: '',
				money: 0,
				actualAmount:'',
				front_img:'',
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
			this.money = this.$route.query.money ? this.$route.query.money : "";
			this.start();
		},
		methods: {
			onOversize() {
				this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
				if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
					this.$toast(this.$t('account.supportPicture'));
					return false;
				}
				return true;
			},
			afterRead1(file) {
				let formData = new FormData();
				formData.append('language', this.$i18n.locale||"en_us");
				formData.append('file', file.file);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.front_img = r.data.data;
					} else {
						if (r.data.info) {
							this.$toast(r.data.info);
						} else {
							this.$toast(this.$t('account.uploadFail'));
						}
					}
				});
			},
			copy(value) {
				var input = document.createElement("input"); // 创建input对象
				input.value = value; // 设置复制内容
				document.body.appendChild(input); // 添加临时实例
				input.select(); // 选择实例内容
				document.execCommand("Copy"); // 执行复制
				document.body.removeChild(input); // 删除临时实例
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			start() {
				Fetch("/user/recharge_info", {
					orderId: this.$route.query.orderId
				}).then((r) => {
					this.data = r.data;
					this.changeAmount();
				});
			},
			submitBtn() {
				if(!this.front_img){
					this.$toast(this.$t('Please upload your payment voucher.'));
					return false;
				}
				Fetch("/user/recharge_apply", {
					id: this.data.orderId,
					voucher: this.front_img
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/task");
					}
				});
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment.mark+")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num)+")";
				}
			}
		},
	};
</script>

<style lang="less" scoped>
	.bankrecharge_wrap {
		background: #fff !important;
		width: 100%;
		min-height: 100%;
		/*position: fixed;*/
	}
	.red_top_bg{
		background: #76b900;
	}
	.bank_detail {
		width: 96%;
		margin-left: 2%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: 12px;
		padding: 10px 16px;
		font-size: 14px;

		.item {
			height: 52px;
			border-bottom: 1px solid #ececec;
			line-height: 52px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.info {
				font-weight: bold;
				color: #000;
				span:nth-child(1){
					font-weight: initial;
				}
				span:nth-child(2){
					color: #999;
					font-size: 14px;
				}
			}

			.copy_btn {
				color: #3d96ff;
				font-size: 12px;
			}
		}
	}

	.warming {
		margin-top: 17px;
		padding: 0 14px;

		.tit {
			font-size: 14px;
			color: rgba(0, 0, 0, .8);
			line-height: 20px;
			font-weight: bold;
		}

		.content {
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			line-height: 17px;
			margin-top: 9px;
		}
	}

	.basic_btn {
		margin: 30px auto 20px auto;
		/*background: linear-gradient(90deg, #672ee4 0%, #16b4ff 100%);*/
	}
	.img1 {
		width: 100%;
	}

</style>
